import type { Color } from 'libs/contentful/types';
import { BackgroundColor, Colorways, EnterpriseBackgroundColor } from 'types/constants';

export const MIN_COLS = 3;
export const MAX_COLS = 5;
export const COLS_TO_SKIP = 2; // Skip the first (description) and second (Chime) columns

export const INIT_COL_CLASS = 'init';

export const DEFAULT_HIGHLIGHT_COLOR: Color = { name: Colorways.ActionPrimary, value: '' };

const DARK_COLORWAY_CLASSES = new Set<BackgroundColor | EnterpriseBackgroundColor>([
  ...Object.values(BackgroundColor).filter(
    c => c.includes('dark') || c === BackgroundColor.AccentRed500 || c === BackgroundColor.AccentPink600,
  ),
  ...Object.values(EnterpriseBackgroundColor).filter(c => c.includes('dark')),
]);

export const isDarkColorway = (colorwayClass: BackgroundColor | EnterpriseBackgroundColor): boolean =>
  DARK_COLORWAY_CLASSES.has(colorwayClass);

export const isGradientColorway = (colorwayClass: string): boolean => colorwayClass.includes('gradient');
